import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-green-600 to-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">QN</span>
              </div>
              <div>
                <h3 className="font-bold text-gray-900">Quba Nügədi Villa</h3>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Təbiətin qoynunda rahat və xatirələnəsi tətil.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Sürətli Keçidlər</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-gray-600 hover:text-green-600 transition-colors">Ana Səhifə</Link></li>
              <li><Link to="/about" className="text-sm text-gray-600 hover:text-green-600 transition-colors">Haqqında</Link></li>
              <li><Link to="/amenities" className="text-sm text-gray-600 hover:text-green-600 transition-colors">İmkanlar</Link></li>
              <li><Link to="/pricing" className="text-sm text-gray-600 hover:text-green-600 transition-colors">Qiymətlər</Link></li>
              <li><Link to="/gallery" className="text-sm text-gray-600 hover:text-green-600 transition-colors">Qalereya</Link></li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Əlaqə</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                <a href="tel:+994999949944" className="text-sm text-gray-600 hover:text-green-600 transition-colors">
                  +994 99 994 99 44
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-600">
                  Quba şəhəri, Nügədi 1 kəndi
                </span>
              </li>
            </ul>
          </div>
          
          {/* Working Hours */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">İş Saatları</h3>
            <p className="text-sm text-gray-600 mb-2">Hər gün</p>
            <p className="text-sm font-medium text-green-700">09:00 - 22:00</p>
            <p className="text-sm text-gray-600 mt-4">Rezervasiya üçün əvvəlcədən zəng edin</p>
          </div>
        </div>
        
        <div className="border-t border-gray-300 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-600">
              © 2025 Quba Nügədi Villa. Bütün hüquqlar qorunur.
            </p>
            <p className="text-sm text-gray-500">
              Samir - Əmlak sahibi
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};